import * as PXBColors from '@brightlayer-ui/colors';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const fontWeights = {
    normal: 500,
    bold: 600,
};

const colors = {
    loading: PXBColors.gray[100],
    alarm: PXBColors.red[500],
    normal: PXBColors.blue[500],
};

const useStyles = makeStyles((theme: any) =>
    createStyles({
        content: {
            height: '128px',
            width: '110%',
        },
        errorColor: {
            color: theme.palette.error.main,
            fontWeight: fontWeights.bold,
        },
        primaryColor: {
            color: theme.palette.primary.main,
            fontWeight: fontWeights.bold,
        },
        isOffline: {
            color: theme.palette.error.main,
            fontWeight: fontWeights.bold,
        },
        actionRow: {
            cursor: 'pointer',
        },
    })
);

export { useStyles, fontWeights, colors };
